// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290235/js/" + chunkId + "." + {"44":"b98b4027","225":"ceaa4b87","481":"a78c8763","486":"cb0b6c49","770":"de8b6fc1"}[chunkId] + ".0.2935047021353683.chunk.js";
};